import React, { createContext, useState, useContext, useEffect } from "react";

// Create a Context
const GlobalContext = createContext();

// Provider Component
export const GlobalProvider = ({ children }) => {
  // Lazy initialization: Reads from localStorage only once
  const getInitialState = () => {
    return JSON.parse(localStorage.getItem("preservedState")) || {
      currency: "CHF",
      country: "CH",
    };
  };

  const [state, setState] = useState(getInitialState);

  // Sync state changes to localStorage
  useEffect(() => {
    localStorage.setItem("preservedState", JSON.stringify(state));
  }, [state]);

  // Function to update state
  const updateState = (updates) => {
    setState((prevState) => ({ ...prevState, ...updates }));
  };

  return (
    <GlobalContext.Provider value={{ state, updateState }}>
      {children}
    </GlobalContext.Provider>
  );
};

// Custom Hook to use the Global State
export const useGlobalState = () => useContext(GlobalContext);
